import { render, staticRenderFns } from "./cardVoiceSession.vue?vue&type=template&id=32780ce0"
import script from "./cardVoiceSession.vue?vue&type=script&lang=js"
export * from "./cardVoiceSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports